import { PageTitle } from '_metronic/layout/core'

import KumopackProductBox from 'Presentation/Components/KumopackProductBox'
import KumopackColorPreview from 'Presentation/Components/KumopackColorPreview'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import { SkeletonThumbnailWithTitle } from 'Presentation/Components/Loading/Skeleton'

import useViewModel from './ViewModel'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

//////////
// View //
//////////

const ItemSelectionView: React.FC = () => {
	const {
		isLoading,
		disabledSubmitButton,
		mappedOptions,
		mappedProducts,
		mappedAccessories,
		mappedThicknesses,
		mappedOuterMaterials,
		mappedInnerMaterials,
		mappedPrintingOptions,
		mappedFormings,
		minimumOrder,
		onFillMinimumOrder,
		handleSelectItem,
		cancel,
		save,
	} = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-body">
							<div className="row gy-5">
								<div className="col-12">
									<h3 className="text-kumopack-grey-900">Step 2 - เลือกส่วนเสริมของสินค้า (Options)</h3>
								</div>

								{/* Product  */}
								<div className="col-12 text-kumopack-grey-400">
									2.1 เลือกสินค้าที่ผลิตได้ (Products) <span className="required" />
								</div>

								{isLoading &&
									[...Array(6)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-4 col-xl-4"
											key={`product-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedProducts.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-products-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-4 col-xl-4">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('product', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedProducts.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Options */}
								<div className="col-12 text-kumopack-grey-400">
									2.2 เลือกประเภทส่วนเสริม (Options) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`options-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedOptions.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-options-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3 col-xl-3">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('option', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedOptions.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Accessories */}
								<div className="col-12 text-kumopack-grey-400">
									2.3 เลือกประเภทส่วนเสริม (Accessories) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`accessories-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedAccessories.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-accessories-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3 col-xl-3">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('accessory', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedAccessories.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Thicknesses */}
								<div className="col-12 text-kumopack-grey-400">
									2.4 ความหนาของสินค้า (Thicknesses) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`thicknesses-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedThicknesses.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-thicknesses-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3 col-xl-3">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('thickness', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedThicknesses.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Outer Materials */}
								<div className="col-12 text-kumopack-grey-400">
									2.5 เลือกประเภทสีด้านนอก (Outer Materials) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`outer-materials-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedOuterMaterials.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-outer-materials-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3"
											style={{
												width: !isMobileDevice() ? 'max-content' : '100%',
											}}>
											<KumopackColorPreview
												{...item}
												onClick={() => handleSelectItem('outer-material', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedOuterMaterials.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Inner Materials */}
								<div className="col-12 text-kumopack-grey-400">
									2.6 เลือกประเภทสีด้านใน (Inner Materials) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											key={`inner-materials-skeleton-${idx}`}
											className="col-12 col-sm-6 col-lg-3"
											style={{
												width: !isMobileDevice() ? 'max-content' : '100%',
											}}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedInnerMaterials.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-inner-materials-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3"
											style={{
												width: !isMobileDevice() ? 'max-content' : '100%',
											}}>
											<KumopackColorPreview
												{...item}
												onClick={() => handleSelectItem('inner-material', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedInnerMaterials.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Printing Options */}
								<div className="col-12 text-kumopack-grey-400">
									2.7 เลือกประเภทงานพิมพ์ (Printing Options) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`printing-options-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedPrintingOptions.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-printing-options-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3 col-xl-3">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('printing-option', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedPrintingOptions.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}

								{/* Forming */}
								<div className="col-12 text-kumopack-grey-400">
									2.8 เลือกประเภทการขึ้นรูป (Forming) <span className="required" />
								</div>

								{isLoading &&
									[...Array(4)].map((_, idx) => (
										<div
											className="col-12 col-sm-6 col-lg-3 col-xl-3"
											key={`forming-skeleton-${idx}`}>
											<SkeletonThumbnailWithTitle />
										</div>
									))}
								{!isLoading &&
									mappedFormings.map((item: any, itemIdx: any) => (
										<div
											key={`${item.nameTh}-formings-${itemIdx}`}
											className="col-12 col-sm-6 col-lg-3 col-xl-3">
											<KumopackProductBox
												{...item}
												onClick={() => handleSelectItem('forming', itemIdx, !item.active)}
											/>
										</div>
									))}
								{!isLoading && mappedFormings.length === 0 && (
									<div className="text-kumopack-grey-500 text-center">ไม่พบข้อมูล</div>
								)}
							</div>
						</div>
					</div>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-body">
							<div className="row gy-5">
								<div className="col-12">
									<h3 className="text-kumopack-grey-900">Step 3 - รายละเอียดเพิ่มเติมของสินค้า</h3>
								</div>

								<div className="col-12">
									<FormGenerator
										formKey="minimumOrder"
										inputType="plain"
										label="จำนวนสินค้าขั้นต่ำ"
										additionalLabelCom={<span className="required" />}
										placeholder="กรุณากรอกจำนวนสินค้าขั้นต่ำ"
										containerClassName="col-12 col-lg-4 col-xl-4"
										tooltip='จำนวนสินค้าขั้นต่ำที่ต้องการผลิต หากไม่มีจำนวนสินค้าขั้นต่ำ กรุณาใส่ "0"'
										value={minimumOrder}
										onChange={onFillMinimumOrder}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-footer text-end">
							<button className="btn btn-sm white-button me-5" onClick={cancel}>
								ยกเลิก
							</button>

							<button
								className="btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white"
								disabled={disabledSubmitButton}
								onClick={save}>
								บันทึก
							</button>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'General',
						path: '/general',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Production',
						path: '/general/production',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Setting',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Production Setting
			</PageTitle>

			{children}
		</>
	)
}

export default ItemSelectionView
